import Autocomplete from "@mui/material/Autocomplete";

import { CreateTwoTone } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import Alert from "@material-ui/lab/Alert";
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../hooks/useToast";
import Formservice from "./../service/Formservice";
import logo from "./logo.png";
import Menu from "./Menu";
import Message from "./Message";
import Phone from "./Phone";
import Identifiant from "./reusable/Identifiant";
import NB from "./reusable/NB";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const INIT_FORM_ERROR = {
  date_debut_error: null,
  date_fin_error: null,
  organisme_error: null,
  domaine_error: null,
  soud_domaine_error: null,
  poste_error: null,
  mission_error: null,
  atttestation_error: null,
};

function Experience() {
  const navigate = useNavigate();
  const ref = localStorage.getItem("ref");
  const [domaine, setDomaine] = useState([]);
  const [loadingData, setLoadingData] = useState({
    domaine: false,
    sousdomaine: false,
  });
  const [sousdomaine, setSousdomaine] = useState([]);
  const [isautre, setAutres] = useState(false);
  const [plus, setPlus] = useState(false);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [number, setNumber] = useState([
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    " ",
    "",
  ]);
  const [compt, setCompt] = useState(false);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [isPhoneNumberLengthNotValid, setPhoneNumberLengthNotValid] =
    useState(false);
  const apiurl = process.env.REACT_APP_API_FILE;
  const [compt1, setCompt1] = useState(false);
  const [isPhoneNumberEmpty1, setIsPhoneNumberEmpty1] = useState(false);
  const [isPhoneNumberLengthNotValid1, setPhoneNumberLengthNotValid1] =
    useState(false);
  const [isdom, setIsdom] = useState(false);
  const parts = ref.split("_");
  const prefix = parts[0];
  const [isEdit, setIsEdit] = useState(false);
  const theme = useTheme();
  const { Toast, showToast } = useToast();

  const formRef = useRef(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [reference, setReference] = useState({
    nom_empl: "",
    email: "",
    num: "",
    nom_empl1: "",
    email1: "",
    num1: "",
  });
  const [message, setMessage] = useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;

  function convertDate(inputDate) {
    let parts = inputDate.split("/");
    let formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    return formattedDate;
  }

  const [form, setForm] = useState({
    id: "",
    date_debut: "",
    date_fin: "",
    entreprise: "",
    domaine: null,
    sous_domaine: null,
    poste: "",
    mission: "",
    attestation: [],
    ref: "",
    type: "",
    fin_contrat: "",
    expr_himo_et_mob_social: "non",
  });

  const [tableData, setTableData] = useState([]);

  function handleFocusPhoneNumber() {
    setIsPhoneNumberEmpty(false);
    setPhoneNumberLengthNotValid(false);
  }

  function handleFocusPhoneNumber1() {
    setIsPhoneNumberEmpty1(false);
    setPhoneNumberLengthNotValid1(false);
  }

  const handleChange11 = (event) => {
    const { name, value } = event.target;
    var i = 0;
    var a = 0;
    for (let index = 0; index < value.length; index++) {
      for (let indexs = 0; indexs < number.length; indexs++) {
        if (number[indexs] == value[index]) {
          i++;
        }
      }
    }
    if (i != value.length) {
      setCompt1(true);
    } else {
      setCompt1(false);
      setReference({ ...reference, [name]: value });
    }
  };

  const handleCheckFormError = () => {
    setFormErrors({
      atttestation_error:
       /*  (!form.attestation ||
        form.attestation === "" ||
        form.attestation?.length === 0) && form.fin_contrat !== "Présent"
          ? "Attestation requise"
          : */ 
          identif.id_type >= 2 ? "Attestation requise" : null,
      date_debut_error: !form.date_debut
        ? "Date de debut requise"
        : dayjs(form.date_debut).isAfter(dayjs()) && !form.fin_contrat
          ? "Date de debut doit être inférieur ou égale à la date actuelle"
          : null,
      date_fin_error:
        !form.date_fin && !form.fin_contrat
          ? "Date de fin invalide"
          : dayjs(form.date_fin).isBefore(dayjs(form.date_debut)) &&
              !form.fin_contrat
            ? "Date de fin doit être supérieur à la date de début"
            : dayjs(form.date_fin).get("year") > dayjs().get("year") + 50
              ? "Veuillez verifier votre date de fin"
              : null,
      domaine_error: !form.domaine ? "Domainde de competence requis" : null,
      mission_error: !form.mission ? "Description du mission requise" : null,
      organisme_error: !form.entreprise ? "Organisme/Entreprise requise" : null,
      poste_error: !form.poste ? "Poste requis" : null,
      soud_domaine_error: !form.sous_domaine ? "Sous domaine requise" : null,
      statut_error:
        !form.type && identif.desc !== "Cons_indiv"
          ? "Statut d'emploi requis"
          : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    var i = 0;
    var a = 0;
    for (let index = 0; index < value.length; index++) {
      for (let indexs = 0; indexs < number.length; indexs++) {
        if (number[indexs] == value[index]) {
          i++;
        }
      }
    }
    if (i != value.length) {
      setCompt(true);
    } else {
      setCompt(false);
      setReference({ ...reference, [name]: value });
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const handleplus = () => {
    setPlus(true);
  };

  const handleChangeref = (event) => {
    const { name, value } = event.target;
    setReference({ ...reference, [name]: value });
  };

  function onFileChange(event) {
    const file = event.target.files[0];

    if (file) {
      const fileSize = file.size;
      const maxFileSize = 3 * 1024 * 1024;

      if (fileSize > maxFileSize) {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo:
            "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });

        event.target.value = "";
        setForm({ ...form, attestation: "" });
      } else {
        setForm({ ...form, attestation: file });
        setIsEdit(false);
      }
    }
  }

  const handleFetshSousDomaineByIdDomaine = (id_domaine) => {
    setLoadingData({ ...loadingData, sousdomaine: true });
    Formservice.sousdomaine(id_domaine)
      .then((result) => {
        if (result && result.data) {
          if (identif?.desc === "Cons_indiv") {
            setSousdomaine(
              result.data.filter((item) => item.name !== "Autres"),
            );
          } else {
            setSousdomaine(result.data);
          }
        }
      })
      .finally(() => {
        setLoadingData({ ...loadingData, sousdomaine: false });
      });
  };

  const handleChangedomaine = (event, value) => {
    if (value) {
      const idvar = value.id_domaine;
      setForm({ ...form, domaine: value, sous_domaine: null });
      setIsdom(value.name === "Autres");
      handleFetshSousDomaineByIdDomaine(idvar);
    } else {
      setForm({ ...form, domaine: null });
    }
  };

  const handleChangeautre = (event) => {
    const newValue = event.target.value;
    setForm({ ...form, sous_domaine: { name: newValue } });
  };

  const handleChangeautredomaine = (event) => {
    const newValue = event.target.value;
    setForm({ ...form, domaine: { name: newValue } });
  };

  const [identif, setIdentif] = useState({});

  useEffect(() => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        setTableData(result.exp);
      }
    });
  }, []);

  useEffect(() => {
    if (identif) {
      handleFetchDomaine(identif);
    }
  }, [identif]);

  useEffect(() => {
    handleCheckFormError();
  }, [form]);

  const isFormError = () => {
    return Object.values(formErrors).some((item) => item !== null);
  };

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr.includes("/")) {
      return dateStr;
    }
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateStr;
  };

  const objAlreadyExist = () => {
    return tableData.some(
      (item) =>
        formatDateToDDMMYYYY(item.date_debut) ===
          formatDateToDDMMYYYY(form.date_debut) &&
        formatDateToDDMMYYYY(item.date_fin) ===
          formatDateToDDMMYYYY(form.date_fin) &&
        String(item.description_experience).toLowerCase() ===
          String(form.mission).toLowerCase() &&
        String(item.domaine_experience).toLowerCase() ===
          String(form.domaine?.name).toLowerCase() &&
        String(item.experience_mission).toLowerCase() ===
          String(form.poste).toLowerCase() &&
        String(item.organisme_experience).toLowerCase() ===
          String(form.entreprise).toLowerCase() &&
        String(item.sous_domaine_experience).toLowerCase() ===
          String(form.sous_domaine?.name).toLowerCase() &&
        String(item.statut).toLowerCase() === String(form.type).toLowerCase() &&
        String(item.reference).toLowerCase() ===
          String(reference.nom_empl).toLowerCase() &&
        String(item.email_ref).toLowerCase() ===
          String(reference.email).toLowerCase() &&
        String(item.num_ref).toLowerCase() ===
          String(reference.num).toLowerCase() &&
        String(item.reference2).toLowerCase() ===
          String(reference.nom_empl1).toLowerCase() &&
        String(item.email_ref2).toLowerCase() ===
          String(reference.email1).toLowerCase() &&
        String(item.num_ref2).toLowerCase() ===
          String(reference.num1).toLowerCase(),
    );
  };

  const handleSave = () => {
    setSubmited(true);
    if (isFormError()) {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
      return;
    }
    if (form.id === "" && objAlreadyExist()) {
      showToast(TYPE_NOTIFICATION.ERROR, "Ces informations sont dejà inserées");
      return;
    }
    setLoadingAdd(true);
    if (form.id !== "") {
      Formservice.updateexperience(form, ref, reference, form.id)
        .then((result) => {
          if (result.status) {
            setSubmited(false);
            setMessage({
              ...message,
              open: true,
              color: "green",
              messageInfo: "Succès",
            });
            setTableData(result.data);
            setForm({
              date_debut: "",
              date_fin: "",
              entreprise: "",
              domaine: null,
              sous_domaine: null,
              poste: "",
              mission: "",
              attestation: "",
              ref: "",
              type: "",
              fin_contrat: "",
              id: "",
              expr_himo_et_mob_social: "",
            });
            setReference({
              nom_empl: "",
              email: "",
              num: "",
              nom_empl1: "",
              email1: "",
              num1: "",
            });
            setPlus(false);
            setAutres(false);
            setIsdom(false);
            document.getElementById("attestation").value = "";
            setIsEdit(false);
          } else {
            setMessage({
              ...message,
              open: true,
              color: "red",
              messageInfo: "Erreur lors de la mise à jour",
            });
          }
        })
        .catch((err) => {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de le mise à jour",
          });
        })
        .finally(() => {
          setLoadingAdd(false);
        });
    } else {
      Formservice.saveexperience(form, ref, reference)
        .then((result) => {
          if (result.status) {
            setSubmited(false);
            setMessage({
              ...message,
              open: true,
              color: "green",
              messageInfo: "Succès",
            });
            setTableData(result.data);
            setForm({
              date_debut: "",
              date_fin: "",
              entreprise: "",
              domaine: null,
              sous_domaine: null,
              poste: "",
              mission: "",
              attestation: "",
              ref: "",
              type: "",
              fin_contrat: "",
              id: "",
              expr_himo_et_mob_social: "",
            });
            setReference({
              nom_empl: "",
              email: "",
              num: "",
              nom_empl1: "",
              email1: "",
              num1: "",
            });
            setPlus(false);
            setAutres(false);
            setIsdom(false);
            document.getElementById("attestation").value = "";
            setIsEdit(false);
          } else {
            setMessage({
              ...message,
              open: true,
              color: "red",
              messageInfo: "Erreur lors de l'insertion",
            });
          }
        })
        .catch((err) => {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de l'insertion",
          });
        })
        .finally(() => {
          setLoadingAdd(false);
        });
    }
  };

  const handleDelete = (index) => {
    Formservice.deleteexperience(index, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          setTableData(result.data);
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de la suppression",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "Erreur lors de la suppression",
        });
      });
  };

  const handleEdit = (index) => {
    let result = tableData.find((item) => item.id_experience === index);
    setForm({
      id: result.id_experience,
      date_debut: convertDate(result.date_debut),
      date_fin: convertDate(result.date_fin),
      entreprise: result.organisme_experience,
      domaine: {
        id_domaine: result.domaine_experience,
        name: result.domaine_experience,
      },
      sous_domaine: {
        id_sous_domaine: result.sous_domaine_experience,
        name: result.sous_domaine_experience,
      },
      poste: result.experience_mission,
      mission: result.description_experience,
      attestation: result.file_experience,
      ref: "",
      type: result.statut,
      fin_contrat: result.fin_contrat,
      expr_himo_et_mob_social: result.expr_himo_et_mob_social,
    });
    setReference({
      email: result.email_ref,
      num: result.num_ref,
      nom_empl: result.reference,
      email1: result.email_ref2,
      nom_empl1: result.reference2,
      num1: result.num_ref2,
    });
    if (result.file_experience !== null) {
      setIsEdit(true);
    }
    handleFetshSousDomaineByIdDomaine(
      domaine.find((item) => item.name === result.domaine_experience)
        ?.id_domaine,
    );
    // Scroller vers le formulaire
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }, 10);
  };

  const handleenvoie = () => {
    const formIsComplete = ["date_debut", "date_fin", "entreprise"].every(
      (field) => form[field] !== "",
    );

    if (formIsComplete) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo:
          "Veuillez d'abord cliquer sur Ajouter ou Modifier avant de continuer.",
      });
    } else if (tableData.length === 0 && identif.poste !== "Stagiaire") {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez compléter le champ",
      });
    } else {
      navigate("/competence");
    }
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  const handleretour = () => {
    navigate("/etude");
  };

  const handleFetchDomaine = (filtre) => {
    let id_type = filtre.id_type || 1;
    setLoadingData({ ...loadingData, domaine: true });
    Formservice.domaine(id_type)
      .then((result) => {
        if (result && result.data) {
          setDomaine(result.data);
        }
      })
      .finally(() => {
        setLoadingData({ ...loadingData, domaine: false });
      });
  };

  return (
    <>
      <Toast />
      <Grid
        container
        ref={formRef}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Message
          open={open}
          color={color}
          messageInfo={messageInfo}
          handleClose={handleCloseMessage}
        />

        <Menu />
        <Grid
          item
          xs={12}
          md={10}
          lg={7}
          minHeight={"90vh"}
          borderRadius={"20px"}
          border={"2px rgba(11, 93, 208,0.5) solid "}
          boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
          display={"flex"}
          flexDirection={"column"}
          p={2.5}
        >
          <main>
            <Grid container item xs={12} justifyContent={"center"}>
              <img
                src={logo}
                className="App-logo"
                alt="logo"
                style={{
                  maxWidth: "75px",
                  maxHeight: "75px",
                  // marginLeft: "40%",
                  // display: window.innerWidth <= 600 ? "block" : "none",
                }}
              />
            </Grid>

            <Grid container display={"flex"} justifyContent={"center"}>
              <Grid container item xs={12} justifyContent="center">
                <h1 style={{ marginBottom: "10px" }}>
                  Expériences professionnelles et stages
                </h1>
              </Grid>
              <Grid container>
                <Grid item xs={12} md={6} style={{ marginBottom: "10px" }}>
                  <Identifiant identif={identif} prefix={prefix} refer={ref} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  style={{ marginBottom: "20px", color: "red" }}
                >
                  <NB
                    texts={[
                      "Tous les champs avec * sont obligatoires",
                      "Le bouton Ajouter permet d'enregistrer les experience.",
                      "Veuillez cliquer sur suivant pour passer au suivant.",
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid item>
                <fieldset>
                  <legend>Experiences</legend>
                  <TableContainer
                    component={Paper}
                    sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
                    style={{
                      marginTop: "10px",
                      marginBottom: "20px",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow
                          style={{ backgroundColor: "gray", padding: "0px" }}
                        >
                          <TableCell>Date début</TableCell>
                          <TableCell>Date fin</TableCell>
                          <TableCell>Entreprise</TableCell>
                          <TableCell>Domaine</TableCell>
                          <TableCell>Sous_domaine</TableCell>
                          <TableCell>Statut d'emploi</TableCell>
                          <TableCell>Poste occupée</TableCell>
                          <TableCell>Mission</TableCell>
                          <TableCell>PJ</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData.map((data, index) => (
                          <TableRow key={index}>
                            <TableCell>{data.date_debut}</TableCell>
                            <TableCell>
                              {data.fin_contrat === "Présent"
                                ? "En cours"
                                : data.date_fin}
                            </TableCell>
                            <TableCell>{data.organisme_experience}</TableCell>
                            <TableCell>{data.domaine_experience}</TableCell>
                            <TableCell>
                              {data.sous_domaine_experience}
                            </TableCell>
                            <TableCell>{data.statut}</TableCell>
                            <TableCell>{data.experience_mission}</TableCell>
                            <TableCell>{data.description_experience}</TableCell>
                            <TableCell>
                              {data.file_experience == "" ? (
                                ""
                              ) : (
                                <a
                                  href={`${apiurl}/uploads/attestation/${data.file_experience}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  PJ
                                </a>
                              )}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                aria-label="edit"
                                color="primary"
                                onClick={() => handleEdit(data.id_experience)}
                              >
                                <CreateTwoTone />
                              </IconButton>
                              <IconButton
                                aria-label="delete"
                                color="secondary"
                                onClick={() => handleDelete(data.id_experience)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Date de début * :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        style={{ width: "100%", marginBottom: "15px" }}
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        type="date"
                        required
                        value={form.date_debut}
                        name="date_debut"
                        error={submited && formErrors.date_debut_error}
                        helperText={submited ? formErrors.date_debut_error : ""}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Date de fin * :</label>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        style={{ width: "100%", marginBottom: "15px" }}
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        type="date"
                        required
                        value={
                          form.fin_contrat === "Présent" ? "" : form.date_fin
                        }
                        disabled={form.fin_contrat === "Présent"}
                        error={submited && formErrors.date_fin_error}
                        helperText={submited ? formErrors.date_fin_error : ""}
                        name="date_fin"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormGroup
                        style={{ width: "100%", marginBottom: "15px" }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="Présent"
                              checked={form.fin_contrat === "Présent"}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  fin_contrat: e.target.checked
                                    ? "Présent"
                                    : null,
                                  date_fin: e.target.checked
                                    ? null
                                    : form.date_fin ||
                                      dayjs().format("YYYY-MM-DD"),
                                })
                              }
                            />
                          }
                          label="J’y travaille à présent"
                          name="fin_contrat"
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <label>
                        Etablissement/Employeur (Organisme, Entreprise,
                        Association, etc.) * :{" "}
                      </label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        style={{ width: "100%", marginBottom: "15px" }}
                        id="outlined-basic"
                        size="small"
                        value={form.entreprise}
                        label={
                          "Etablissement/Employeur ou Lieu de travail (Organisme, Entreprise,Association, etc.) "
                        }
                        error={submited && formErrors.organisme_error}
                        helperText={submited ? formErrors.organisme_error : ""}
                        variant="outlined"
                        name="entreprise"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Domaine * :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        loading={loadingData.domaine || false}
                        loadingText={"Chargement de données..."}
                        options={form.desc === "Cons_int" ? domaine : [...domaine, { id_domaine: "Autres", name: "Autres" }]}
                        value={form.domaine || null}
                        getOptionLabel={(option) => option.name}
                        style={{ width: "100%", marginBottom: "15px" }}
                        onChange={handleChangedomaine}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Sélectionnez un domaine"
                            error={submited && formErrors.domaine_error}
                            helperText={
                              submited ? formErrors.domaine_error : ""
                            }
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    {isdom && (
                      <>
                        <Grid item xs={12}>
                          <label>Autres domaine * :</label>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            label="Autres domaine"
                            variant="outlined"
                            name="autre"
                            onChange={handleChangeautredomaine}
                            error={submited && formErrors.domaine_error}
                            helperText={
                              submited ? formErrors.domaine_error : ""
                            }
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12}>
                      <label>Sous domaine * :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        loading={loadingData.sousdomaine || false}
                        loadingText={"Chargement de données..."}
                        options={
                          ["Cons_indiv", "Cons_ext"].includes(identif?.desc)
                            ? sousdomaine
                            : [
                                ...sousdomaine,
                                { id_sous_domaine: "Autres", name: "Autres" },
                              ]
                        }
                        value={form.sous_domaine || null}
                        getOptionLabel={(option) => option.name}
                        style={{ width: "100%" }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setForm({ ...form, sous_domaine: newValue });
                            if (newValue.name === "Autres") {
                              setAutres(true);
                            }
                          } else {
                            setForm({ ...form, sous_domaine: null });
                            setAutres(false);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={submited && formErrors.soud_domaine_error}
                            helperText={
                              submited ? formErrors.soud_domaine_error : ""
                            }
                            label="Sélectionnez un sous_domaine"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    {isautre && (
                      <>
                        <Grid item xs={12}>
                          <label>Autres sous_domaine * :</label>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            label="Autres sous_domaine"
                            variant="outlined"
                            name="autre"
                            error={submited && formErrors.soud_domaine_error}
                            helperText={
                              submited ? formErrors.soud_domaine_error : ""
                            }
                            onChange={handleChangeautre}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid
                      item
                      xs={12}
                      style={{
                        display:
                          identif.desc === "Cons_indiv" ? "none" : "flex",
                      }}
                    >
                      <label>Statut d'emploi * :</label>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        fontSize: "20px",
                        display:
                          identif.desc === "Cons_indiv" ? "none" : "flex",
                      }}
                    >
                      <FormGroup row sx={{ width: "100%" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="Consultant"
                              checked={form.type === "Consultant"}
                              onChange={handleChange}
                            />
                          }
                          label="Consultant"
                          name="type"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="Salarié"
                              checked={form.type === "Salarié"}
                              onChange={handleChange}
                            />
                          }
                          label="Salarié"
                          name="type"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="Stagiaire"
                              checked={form.type === "Stagiaire"}
                              onChange={handleChange}
                            />
                          }
                          label="Stagiaire"
                          name="type"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <FormHelperText
                        error={submited && formErrors.statut_error}
                        sx={{
                          display:
                            submited && formErrors.statut_error
                              ? "block"
                              : "none",
                        }}
                      >
                        <Alert severity="error" variant="outlined">
                          {submited && formErrors.statut_error}
                        </Alert>
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                      <label>Poste occupée * :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "100%" }}
                        id="outlined-basic"
                        size="small"
                        label="Poste occupée"
                        variant="outlined"
                        name="poste"
                        value={form.poste}
                        error={submited && formErrors.poste_error}
                        helperText={submited ? formErrors.poste_error : ""}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Missions * :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "100%", marginBottom: "10px" }}
                        id="outlined-basic"
                        size="small"
                        label="Missions"
                        variant="outlined"
                        name="mission"
                        multiline
                        rows={5}
                        value={form.mission}
                        error={submited && formErrors.mission_error}
                        helperText={submited ? formErrors.mission_error : ""}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Pour obtenir références de ce poste :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <label>Nom et prénoms de la personne référante :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "100%" }}
                        id="outlined-basic"
                        size="small"
                        label="Nom employeur"
                        variant="outlined"
                        name="nom_empl"
                        value={reference.nom_empl}
                        onChange={handleChangeref}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Email :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "100%" }}
                        id="outlined-basic"
                        size="small"
                        label=""
                        name="email"
                        value={reference.email}
                        onChange={handleChangeref}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Numéro téléphone :</label>
                    </Grid>
                    <Grid item xs={12}>
                      <Phone
                        x1={3}
                        x2={8}
                        name="num"
                        value={reference.num}
                        onChange={handleChange1}
                        onFocus={handleFocusPhoneNumber}
                      />
                      {compt && (
                        <>
                          <Alert severity="error">
                            Le numero de téléphone ne contient pas de lettres
                          </Alert>
                        </>
                      )}
                      {isPhoneNumberEmpty && (
                        <>
                          <Alert severity="error">
                            Ce champ est obligatoire
                          </Alert>
                        </>
                      )}
                      {isPhoneNumberLengthNotValid && (
                        <>
                          <Alert severity="error">
                            Veuillez vérifier votre numéro de téléphone. La
                            longueur n'est pas valide
                          </Alert>
                        </>
                      )}
                    </Grid>
                    {!plus && (
                      <>
                        <Grid item xs={12}>
                          <Button onClick={handleplus}>
                            <AddIcon />
                            Ajouter plus de références
                          </Button>
                        </Grid>
                      </>
                    )}
                    {plus && (
                      <>
                        <Grid item xs={12}>
                          <label>Nom et Prénom(s) :</label>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            style={{ width: "100%" }}
                            id="outlined-basic"
                            size="small"
                            label="Nom employeur"
                            variant="outlined"
                            name="nom_empl1"
                            value={reference.nom_empl1}
                            onChange={handleChangeref}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label>Email :</label>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            style={{ width: "100%" }}
                            id="outlined-basic"
                            size="small"
                            label=""
                            variant="outlined"
                            name="email1"
                            value={reference.email1}
                            onChange={handleChangeref}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label>Numéro téléphone :</label>
                        </Grid>
                        <Grid item xs={12}>
                          <Phone
                            x1={3}
                            x2={8}
                            name="num1"
                            value={reference.num1}
                            onChange={handleChange11}
                            onFocus={handleFocusPhoneNumber1}
                          />
                          {compt1 && (
                            <>
                              <Alert severity="error">
                                Le numero de téléphone ne contient pas de
                                lettres
                              </Alert>
                            </>
                          )}
                          {isPhoneNumberEmpty1 && (
                            <>
                              <Alert severity="error">
                                Ce champ est obligatoire
                              </Alert>
                            </>
                          )}
                          {isPhoneNumberLengthNotValid1 && (
                            <>
                              <Alert severity="error">
                                Veuillez vérifier votre numéro de téléphone. La
                                longueur n'est pas valide
                              </Alert>
                            </>
                          )}
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12}>
                      <label>Attestation/Certificat bonne fin:</label>
                    </Grid>
                    <Grid item xs={12}>
                      <input
                        type="file"
                        id="attestation"
                        name="attestation"
                        accept=".pdf, .jpg, .jpeg, .png"
                        onChange={onFileChange}
                        style={{ width: "100%", marginBottom: "10px" }}
                      />
                      {isEdit && form.attestation && (
                        <a
                          href={`${apiurl}/uploads/attestation/${form.attestation}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "10px",
                            textDecoration: "none",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "block",
                            width: "100%",
                            marginTop: "5px",
                          }}
                        >
                          {form.attestation}
                        </a>
                      )}
                      <FormHelperText sx={{ color: "error.main" }}>
                        {submited ? formErrors.atttestation_error : ""}
                      </FormHelperText>
                      <Grid mb={1}>
                        <Alert
                          sx={{
                            mb: 1,
                          }}
                          severity="info"
                          variant="outlined"
                        >
                          Format du fichier accepté: pdf, Taille max : 3Mo
                        </Alert>
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="end">
                      <LoadingButton
                        variant="contained"
                        color="primary"
                        loading={loadingAdd}
                        style={{ fontWeight: 400, marginBottom: "10px" }}
                        onClick={handleSave}
                      >
                        {form.id === "" ? "Ajouter" : "Modifier"}
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            </Grid>
            <Grid
              item
              mt={3}
              mb={3}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Button variant="outlined" onClick={handleretour}>
                Retour
              </Button>
              <LoadingButton
                variant="outlined"
                sx={{ marginLeft: "auto" }}
                onClick={handleenvoie}
                color="primary"
              >
                Suivant
              </LoadingButton>
            </Grid>
          </main>
          <footer
            style={{
              color: "#0747a1",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE
            DEVELOPPEMENT
          </footer>
        </Grid>
      </Grid>
    </>
  );
}

export default Experience;
